import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';

const entityKey = 'userAgreements';

const stateReducer = combineReducers({
    records: recordsReducer,
});

export default stateReducer;
